export class CareTeam{
    PatientCareTeamID: string = "";
    referral_code: string = "";
    PATIENT_ACCOUNT: string = "";
    PRACTICE_CODE: string = "";
    LASTNAME: string = "";
    FIRSTNAME: string = "";
    RELATION: string = "";
    ADDRESS: string = "";
    PHONE: string = "";
    FAX: string = "";
    EMAIL: string = "";
    SPECIALITY: string = "";
    REFERRINGPROVIDER: boolean = false;
    PCP: boolean = false;
    OTHER: boolean = false;
    Zip: string = "";
    City: string = "";
    State: string = "";
    TITLE: string = "";
    SUFFIX: string = "";
    Created_date: string = "";
    Created_By: string = "";
    Modified_Date: string = "";
    TalkMD_MODIFIED_DATE: string = "";
    Modified_By: string = "";
    NPI: string = "";
}

export class modelCareTeam
{
    address!: string;
    city!: string;
    created_By!: string;
    created_date!: string;
    email!: string;
    fax!: string;
    firstname!: string;
    lastname!: string;
    modified_By!: string;
    modified_Date!: string;
    npi!: string;
    other: boolean = false;
    patienT_ACCOUNT!: string;
    patientCareTeamID!: string;
    pcp!: string;
    phone!: string;
    practicE_CODE!: string;
    referral_code!: string;
    referringprovider: boolean = false;
    relation!: string;
    speciality!: string;
    state!: string;
    suffix!: string;
    talkMD_MODIFIED_DATE!: string;
    title!: string;
    zip!: string;
}

export class Results {
    addresses: addresses[] = []
    basic!: basic;
    created_epoch!: number;
    enumeration_type: string = "";
    identifiers: identifiers[] = []
    last_updated_epoch!: number;
    number!: string;
    other_names: any[] = []
    taxonomies: taxonomies[] = []
}

export class addresses {
    certification_date: string;
    address_1: string;
    address_2: string;
    address_purpose: string;
    address_type: string;
    city: string;
    country_code: string;
    country_name: string;
    postal_code: string;
    state: string;
    telephone_number: string;
    fax_number: string;
}

export class basic {
    credential: string = "";
    certification_date: string = "";
    enumeration_date: string = "";
    first_name: string = "";
    middle_name: string = "";
    gender: string = "";
    last_name: string = "";
    last_updated: string = "";
    name_prefix: string = "";
    name: string = "";
    sole_proprietor: string = "";
    status: string = "";
}

export class taxonomies {
    code: string = "";
    desc: string = "";
    license: string = "";
    primary: boolean = false;
    state: string = "";
}

export class identifiers {
    code: string = "";
    desc: string = "";
    identifier: string = "";
    issuer: string = "";
    state: string = "";
}

export class AddCareTeamModel {
    PATIENT_ACCOUNT: string ="";
    PRACTICE_CODE: any = "";
    FIRST_NAME: string = "";
    LAST_NAME: string = "";
    TITLE: string = "";
    SUFFIX: string = "";
    faxNumber: string = "";
    PHONE: string = "";
    ADDRESS: string = "";
    ZIP: string = "";
    CITY: string = "";
    STATE: string = "";
    EMAIL: string = "";
    SPECIALITY: string = "";
    REFERRINGPROVIDER: boolean = false;
    provRef: boolean = false;
    PCP: boolean = false;
    OTHER: boolean = false;
    NPI: string = "";
    createdBy: string = "";
    RELATION: string = "";
}


export class SymptommsModel{
    first_name: string = "";
    last_name: string = "";
    visit_date: string = "";
    patient_account: string = "";
    practiceCode: string = "";
    language: string = "";
    feverOrChills: string = "";
    cough: string = "";
    shortnessOfBreathDifficultyBreathing: string = "";
    fatigue: string = "";
    muscleOrBodyAches: string = "";
    headache: string = "";
    newLossOfTasteOrSmell: string = "";
    soreThroat: string = "";
    congestionOrRunnyNose: string = "";
    nauseaOrVomiting: string = "";
    diarrhea: string = "";
    diagnosedOrSuspected: string = "";
    appointment_id: string = "";
    visitReason: string = "";
    travelOutSideNjLastTwoWeak: string = "";
}

export class getZipCode {
    stateCode: string = "";
    cityName: string = "";
    zipCode: string = "";
}

export class UpdateCareTeamModel {
    PATIENT_ACCOUNT: string ="";
    PRACTICE_CODE: any = "";
    FIRST_NAME: string = "";
    LAST_NAME: string = "";
    TITLE: string = "";
    SUFFIX: string = "";
    faxNumber: string = "";
    PHONE: string = "";
    ADDRESS: string = "";
    ZIP: string = "";
    CITY: string = "";
    STATE: string = "";
    EMAIL: string = "";
    SPECIALITY: string = "";
    REFERRINGPROVIDER: boolean = false;
    provRef: boolean = false;
    PCP: boolean = false;
    OTHER: boolean = false;
    NPI: string = "";
    createdBy: string = "";
    RELATION: string = "";
    PATIENT_CARE_TEAM_ID: string = "" ;
}

//intakeForm Model
export class AddMedicationModel{
    PATIENT_ACCOUNT!:string;
    PRACTICE_CODE! :string;
    MEDICINE_CODE!:string;
    MEDICINE_NAME! :string;
    SIG!:string;
    UNIT_CODE!:string;
    DAIG_CODE!:string;
    PATIENT_PRESCTRIPTION_ID!:string;
}

export class GetPostApiParam {
    PatientAccount!: string;
    PracticeCode!: string;
    Query!: string;
    PaginationSize!: string;
    EndTo!: string;
}
